/**
 * Created by WangPing on 2019/7/23.
 */
import './index.less'
import util from "../../assets/javascripts/util";
import interactive from "../../assets/javascripts/interactive";
import {Render, Roll} from "../../assets/javascripts/common";
import '../../assets/javascripts/windvane.js'

if (module.hot) {
    module.hot.accept()
}
let page = new interactive('BannerJSPlugin');

class Main extends Render {
    constructor(bridgeContext) {
        super(bridgeContext);
        this.campaignId = '';
        this.campaignIdList = [];
    }

    getCampaignIdList() {
        this.campaignIdList = this.bridgeContext.campaignList.map(function (item) {
            return item.id
        })
        this.campaignId = this.campaignIdList[0];
    }

    // 初始化执行插入页面元素
    init() {
        this.initCampaignMap(); // 初始化campaignMap
        this.getStar();//获取星星评级
        this.insertCta();// 插入cta文字
        if (this.campaignInfo.title) {
            this.insertTitle();// 插入title
        }
        if (this.campaignInfo.image_url) {
            this.insertImage();
        }
        if (this.campaignInfo.icon_url) {
            this.insertIcon();// 插入icon
        } else {
            let infoIcon = Array.from(document.getElementsByClassName("infoIcon"));
            for (let i of Array.from(infoIcon)) {
                i.classList.add('hide');    //  如果icon url不存在增加hide class隐藏
            }
        }
        if (this.campaignInfo.desc) {
            this.insertDes();// 插入描述
        }
        this.insertJumpUrl(() => {
            page.click({
                bridgeContext: this.bridgeContext,
                campaignMap: this.campaignMap[this.campaignId],
                template: 'banner'
            })
        })
    }
}
// 初始化滚动
function initRoll(){
    const bodyWidth = window.innerWidth;
    const bodyHeight = window.innerHeight;
    const v1 = ((320 / 250) + (320 / 90)) / 2;
    const v2 = ((320 / 90) + (320 / 50)) / 2;
    const v3 = ((320 / 50) + (728 / 90)) / 2;
    const ratio = bodyWidth / bodyHeight;
    if (ratio < v1) {   //  适配 320*250 设计图样式
        document.getElementById("infoDescText").classList.add('line-clamp2')
        const roll1 = new Roll({
            elemBox: document.getElementById("infoRollWrap-320-250"),
            elem: document.getElementById("infoRollBox-320-250"),
            time: '2000',
        });
    } else if (ratio > v1 && ratio < v2) {  //  适配 320*90  设计图样式
        if(document.getElementById("infoDescText").classList.contains("line-clamp2")){
            document.getElementById("infoDescText").classList.remove('line-clamp2')
        }
        const roll2 = new Roll({
            elemBox: document.getElementById("infoRollWrap-320-250"),
            elem: document.getElementById("infoRollBox-320-250"),
            time: '2000',
        });
    } else if (ratio > v2 && ratio < v3) {  //  适配 320*50 设计图样式
        if(document.getElementById("infoDescText").classList.contains("line-clamp2")){
            document.getElementById("infoDescText").classList.remove('line-clamp2')
        }
        const roll3 = new Roll({
            elemBox: document.getElementById("infoRollWrap-320-50"),
            elem: document.getElementById("infoRollBox-320-50"),
            time: '2000'
        });
    } else if (ratio > v3) {    //  适配 728*90 设计图样式
        if(document.getElementById("infoDescText").classList.contains("line-clamp2")){
            document.getElementById("infoDescText").classList.remove('line-clamp2')
        }
        const roll4 = new Roll({
            elemBox: document.getElementById("infoRollWrap-320-250"),
            elem: document.getElementById("infoRollBox-320-250"),
            time: '2000',
        });
    }
}
// 监听广告位尺寸改变
window.onresize=function(){
    if(window.rollTimer){
        // 清除掉之前的定时器
        clearInterval(window.rollTimer);
    }
    // 重置之前设置的外层盒子margin-top为0  避免尺寸改变样式错乱
    document.getElementById("infoRollBox-320-250").style.cssText = "margin-top:0";
    document.getElementById("infoRollBox-320-50").style.cssText = "margin-top:0";
    initRoll();
}
// initRoll();
page.onJSBridgeConnected(function () {
    page.getBridgeContext({
        succ: function (res) {
            let renderDom = new Main(res);
            renderDom.init();
            renderDom.getCampaignIdList();
            page.isReadyStatus(1, function () {
                page.webviewshow(function () {
                    console.log("准备上报only_impression_url")
                    page.reportPv(res);// only_impression_url就发一次,上报banner pv
                    console.log("准备上报campaignid")
                    page.sendImpressions(res)   //上报campaignid
                    page.reportOfferImpression(res);
                    page.initBannerCloseBtn(res);  // 判断是否出关闭按钮
                    if(util.device().isiOS){
                        setTimeout(()=>{
                            initRoll();
                        },500)
                    }else{
                        initRoll();
                    }
                },res)
            })
        }
    })
})


